<template>
  <div class="accessories-view">
    <template v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C" />
    </template>
    <template v-else>
      <inner-navigation>
        <router-link :to="{ name: 'accessories'}">Все аксессуары</router-link>
      </inner-navigation>
      <table-actions>
        <router-link :to="{ name: 'accessory-category-new' }" tag="button">Добавить раздел</router-link>
        <router-link
          :to="{ name: 'accessories-new', params: { id: 'all' }}"
          tag="button"
        >Создать аксессуар</router-link>
      </table-actions>

      <div class="split">
        <div class="split-catalog">
          <p class="header">Разделы</p>
          <accessories-tree
            @select="scrollOnSelect"
            :value="selected"
            @input="updateSelected"
            class="tree"
          />
        </div>
        <div class="split-result" ref="scroll">
          <accessory-list ref="result" :list="selectedCategoriesWithItems" />
        </div>
        <div class="split-nav">
          <p
            class="link"
            v-for="(cat, index) of selectedCategoriesWithItems"
            :key="index"
            @click="scrollTo(cat)"
          >{{ cat.title }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AccessoriesTree from './AccessoriesTree';
import TableActions from '@/components/common/TableActions';

import AccessoryList from './AccessoryList';

import scrollIntoView from 'scroll-into-view-if-needed';

export default {
  name: 'accessories-view',

  components: {
    AccessoriesTree,
    AccessoryList,
    TableActions,
  },

  methods: {
    ...mapActions({
      getConfig: 'accessories/getConfig',
      fetch: 'accessories/fetch',
      fetchCategories: 'accessoryCategories/fetch',
      statuses: 'accessories/statuses',
      changeSelectedCategories: 'accessoryCategories/changeSelectedCategories',
    }),

    updateSelected(selected) {
      this.changeSelectedCategories(selected);
    },

    filterByCategoryId(id) {
      const a = this.accessories.filter(
        accessory => accessory.category_id === id
      );
      return a;
    },

    getSearchResultCategories() {
      return [
        ...new Set(this.accessories.map(accessory => accessory.category_id)),
      ];
    },

    scrollTo(cat) {
      const refs = this.$refs.result.$refs;
      const sectionRef = refs[`cat${cat.id}`];

      if (sectionRef) {
        scrollIntoView(sectionRef[0], {
          scrollMode: 'if-needed',
          behavior: 'smooth',
          inline: 'nearest',
          block: 'nearest',
        });
      }
    },

    scrollOnSelect(val) {
      this.$nextTick(() => this.scrollTo(val));
    },

    openFoundCategories(query) {
      if (query) {
        const selected = this.getSearchResultCategories();
        this.changeSelectedCategories(selected);
      } else {
        this.changeSelectedCategories([]);
      }
    },
  },

  async beforeMount() {
    await this.fetchCategories();

    if (!this.flatCategories.length || !this.statuses.length) {
      await this.getConfig();
    }

    await this.fetch();
  },

  watch: {
    deep: true,
    params: {
      handler: async function(params) {
        await this.fetch();

        this.openFoundCategories(params.search_string);
      },
    },
  },

  computed: {
    ...mapGetters({
      selected: 'accessoryCategories/selectedCategories',
      flatCategories: 'accessoryCategories/flatCategories',
      accessories: 'accessories/list',
      loading: 'accessories/loading',
      error: 'accessories/error',
      meta: 'accessories/meta',
      params: 'accessories/params',
    }),

    categoriesWithItems() {
      return this.flatCategories.map(category => {
        return {
          items: this.filterByCategoryId(category.id),
          ...category,
        };
      });
    },

    selectedCategoriesWithItems() {
      return this.categoriesWithItems
        .filter(category => this.selected.includes(category.id))
        .sort((a, b) => {
          if (a.items.length === 0) return 1;
          if (b.items.length === 0) return -1;
          return 0;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.accessories-view {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;

  .split {
    display: flex;
    flex: 1;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    padding-top: 10px;
    margin-top: 10px;

    .split-catalog {
      display: flex;
      flex-direction: column;
      flex: 1 0 250px;
      max-width: 400px;
      margin-right: 14px;
      overflow-y: auto;
    }

    .split-result {
      flex: 5 0 450px;
      max-width: 900px;
      height: 100%;
      overflow-y: scroll;
    }

    .split-nav {
      flex: 1 1 200px;
      padding-left: 10px;
      overflow-y: auto;

      .link {
        font-size: 18px;
        margin: 16px 0;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .tree {
      flex: 1;
      margin: 14px 0;
    }
  }
}

.header {
  font-size: 20px;
}
</style>
